/**
 * @enum {string}
 */
module.exports = {
    SCREENER: 'screener',
    CHILD_RESCREENING: 'child-rescreening',
    RESOURCE: 'resource',
    SURVEY: 'survey'
};
